import { useEffect, useMemo } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { BreadcrumbSetter } from '@/components/Breadcrumbs'
import { CardTab, DataCardWithTabs } from '@/components/card'
import { TitleSetter } from '@/components/Title'
import { ROUTE_PARAM } from '@/router/constants'
import { useGolfPricingTournamentStore } from '@/stores/golfPricing/tournament.store'
import {
  createTournamentTabs,
  getTournamentHeaderItems,
  TOURNAMENT_TABS
} from '@/views/GolfPricing/Tournament/tournamentView.dde.table'

export const TournamentViewDDE = () => {
  const { tournamentId, '*': tabParam } = useParams()
  const numericTournamentId = tournamentId ? Number(tournamentId) : undefined
  const navigate = useNavigate()

  const {
    data,
    fetchData: fetchTournament,
    resetState: resetTournament
  } = useGolfPricingTournamentStore(
    useShallow((state) => ({
      data: state.data,
      fetchData: state.fetchData,
      resetState: state.resetState
    }))
  )

  useEffect(() => {
    if (!numericTournamentId) return

    fetchTournament({ tournamentId: numericTournamentId })
    return () => {
      resetTournament()
    }
  }, [numericTournamentId])

  const TABS = useMemo(() => createTournamentTabs(), [])
  const DEFAULT_TAB = TOURNAMENT_TABS.LEADERBOARD
  const tab = TABS.some((t) => t.value === tabParam) ? tabParam : undefined

  const tournament = useMemo(
    () => (Array.isArray(data) && data.length > 0 && tournamentId ? data[0] : null),
    [data, tournamentId]
  )

  const title = tournament ? tournament.name : 'Tournament'

  return (
    <>
      <TitleSetter title={title} />
      <BreadcrumbSetter param={ROUTE_PARAM.TOURNAMENT_ID} label={tournament?.name} />
      <DataCardWithTabs
        title={title}
        details={getTournamentHeaderItems(tournament)}
        tabs={TABS}
        currentTab={tab || DEFAULT_TAB}
        onTabChange={(tab) => navigate(`/golf-pricing/${tournamentId}/${tab}`, { replace: true })}
      >
        <CardTab value={TOURNAMENT_TABS.LEADERBOARD}>
          <Outlet />
        </CardTab>
        <CardTab value={TOURNAMENT_TABS.ODDS_DATA}>
          <Outlet />
        </CardTab>
      </DataCardWithTabs>
    </>
  )
}
